import honestySvg from './../svg/honesto.svg';
import responsabilitySvg from './../svg/responsabilidad.svg';
import proactivitySvg from './../svg/proactividad.svg';
import qualitySvg from './../svg/calidad.svg';
import transparencySvg from './../svg/transparencia.svg';
import teamWorkSvg from './../svg/trabajo-en-equipo.svg';
import comunicationSvg from './../svg/comunicacion.svg';
import resolutionSvg from './../svg/resolucion.svg';
import trustSvg from './../svg/confianza.svg';
import disciplineSvg from './../svg/disciplina.svg';
import respectSvg from './../svg/respeto.svg';
import cleaningSvg from './../svg/limpieza.svg';
export const VALUES = [
   {
      icon: honestySvg,
      content: 'Honestidad',
   },
   {
      icon: responsabilitySvg,
      content: 'Responsabilidad',
   },
   {
      icon: proactivitySvg,
      content: 'Proactividad',
   },
   {
      icon: qualitySvg,
      content: 'Calidad',
   },
   {
      icon: transparencySvg,
      content: 'Transpatencia',
   },
   {
      icon: teamWorkSvg,
      content: 'Trabajo en equipo',
   },
   {
      icon: comunicationSvg,
      content: 'Comunicación',
   },
   {
      icon: resolutionSvg,
      content: 'Resolución',
   },
   {
      icon: trustSvg,
      content: 'Confianza',
   },
   {
      icon: disciplineSvg,
      content: 'Disciplina',
   },
   {
      icon: respectSvg,
      content: 'Respeto',
   },
   {
      icon: cleaningSvg,
      content: 'Limpieza',
   },
];



// WEBPACK FOOTER //
// ./src/utils/consts.js